module.exports = __webpack_public_path__ + "static/about-insta-12-2cdcfead7dbbb2e0bde327039d324e30.jpg";